import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChallengeUserPopupStartPage } from './app-challenge-user-popup-start';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChallengeUserPopupStartPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChallengeUserPopupStartPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppChallengeUserPopupStartPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user-popup-start/app-challenge-user-popup-start.module.ts